import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScatterplotBorderedIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 8.4,
		fill: "currentColor",
		fillOpacity: "5%",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgScatterplotBorderedIcon;
